import React, { Component } from 'react';
import '../CSS/newRecord.css';
import GenericNavbar from './Navbar/GenericNavbar';

import SimpleStorageContract from "../contracts/SimpleStorage.json";

import KaspTokens from "../contracts/KaspTokens.json";
import KaspTokenSale from "../contracts/KaspTokenSale.json";


import getWeb3 from "../utils/getWeb3";

import Sidemenu from './Navbar/Sidemenu';

class Coin extends Component
{
    state = {buffer: null, web3: null, accounts: null, contract: null,
        token:'',
        noShare:'',
        enterShare:'',
        numIssue:'',
        address:'',
        totalUsd:'',
        eth:'',
        noCoin:'',
        KaspTokenSaleInstance:'',
        user:null,
    };

    constructor(props)
    {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.enterIssue = this.enterIssue.bind(this);
    }
    enterIssue(e){
        console.log(this.state)
        this.setState({enterShare: e.target.value});
        var x = Number(e.target.value)*Number(this.state.noShare)
        this.setState({totalUsd: x});
        fetch(`https://www.alphavantage.co/query?function=CRYPTO_INTRADAY&symbol=ETH&market=USD&interval=5min&apikey=demo`)
            .then(response => response.json())
            .then(data => {
                if(data['Time Series Crypto (5min)']){
                    var objData = Object.entries(data['Time Series Crypto (5min)']);
                    var min_5 =  Object.entries(objData[0][1]);
                    var closeVal = parseFloat(min_5[3][1]).toFixed(2);
                    console.log(closeVal)
                    this.setState({eth:  (closeVal* this.state.totalUsd) });
                }
            })
    }

    componentDidMount = async () => {
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
			this.setState({user:user});
		}
        if(user.tradsd.amount){
            this.setState({noShare:  user.tradsd.amount});
        }

        fetch(`https://www.alphavantage.co/query?function=CRYPTO_INTRADAY&symbol=ETH&market=USD&interval=5min&apikey=demo`)
            .then(response => response.json())
            .then(data => {
                if(data['Time Series Crypto (5min)']){
                    var objData = Object.entries(data['Time Series Crypto (5min)']);
                    var min_5 =  Object.entries(objData[0][1]);
                    var closeVal = parseFloat(min_5[3][1]).toFixed(2);
                    var conin = (closeVal/0.01);
                    this.setState({noCoin: conin});
                    console.log(conin);
                    console.log(closeVal);
                }
            })
        
        try {
          // Get network provider and web3 instance.
          const web3 = await getWeb3();
          // Use web3 to get the user's accounts.
          const accounts = await web3.eth.getAccounts();
          console.log(accounts[0])
            this.setState({address: accounts[0]})
          // Get the contract instance.

          

          const networkId = await web3.eth.net.getId();

          const KaspTokensInstance = new web3.eth.Contract(
            KaspTokens.abi,
            KaspTokens.networks[networkId] &&
              KaspTokens.networks[networkId].address
          );
          console.log(KaspTokensInstance);

          const KaspTokenSaleInstance = new web3.eth.Contract(
            KaspTokenSale.abi,
            KaspTokenSale.networks[networkId] &&
              KaspTokenSale.networks[networkId].address
          );
          this.setState({KaspTokenSaleInstance: KaspTokenSaleInstance});

          const deployedNetwork = SimpleStorageContract.networks[networkId];
          const instance = new web3.eth.Contract(
            SimpleStorageContract.abi,
            deployedNetwork && deployedNetwork.address,
          );
          console.log(deployedNetwork);
          // Set web3, accounts, and contract to the state, and then proceed with an
          // example of interacting with the contract's methods.
          this.setState({ web3, accounts, contract: instance }, this.runExample);
          this.onGetDate();
        } catch (error) {
          // Catch any errors for any of the above operations.
          alert(
            `Failed to load web3, accounts, or contract. Check console for details.`,
          );
          console.error(error);
        }
      };


    onSubmit(event) {
       // const { accounts, contract } = this.state;
        event.preventDefault()
        /* const { accounts, contract } = this.state;
        event.preventDefault()
        this.onGetDate();
        console.log(this.state);
        contract.methods.addrecordReport(this.state.record_id,this.state.address, this.state.timestamp, this.state.record_code, this.state.description).send({from: accounts[0]});
         */
        // type,per_price,no_issue,address,eth_val
        fetch(`
        http://52.60.64.107/api/orginatorx-new/coin.php?type=${this.state.token}&per_price=${this.state.noShare}&no_issue=${this.state.enterShare}&address=${this.state.address}&user_id=${this.state.user.id}&eth_val=${this.state.eth}
        `).then(response => response.json())
                    .then(data => {
                          this.setState({token: ''});
                          this.setState({noShare: ''});
                          this.setState({eth: ''});

                    }); 

                    //return;

        // console.log(this.state);
         let con = Math.floor( this.state.noCoin);
           con = Number( con );
         let res = this.state.KaspTokenSaleInstance.methods.buyTokens(con).send({
             from: this.state.accounts[0],
             value: con * 1
           });

    }

    onGetDate() {
        var date = new Date();
        var year = date.getFullYear().toString();
        var month = (date.getMonth() + 101).toString().substring(1);
        var day = (date.getDate() + 100).toString().substring(1);
        var hour = (date.getHours() + 100).toString().substring(1);
        var mins = (date.getMinutes() + 100).toString().substring(1);
        var sec = (date.getSeconds() + 100).toString().substring(1);
        this.setState({
            timestamp : year + "-" + month + "-" + day + " " + hour + ":" + mins + ":" + sec
        });
        // console.log(year + "-" + month + "-" + day + " " + hour + ":" + mins + ":" + sec);
      }

    render()
    {
        return(
            <div className = "">
                <GenericNavbar/>
                {this.state.accounts &&
                <p className='wal-address'>{this.state.accounts[0] } </p>
                }
                <div className="container-fluid bg-black">
                <div className="row">
                    <Sidemenu />
                   
                    <div className="col s10">
                        <div className="card reportCard">
                            <div className="card-title cardTitle2">
                                <h4 className = "cardTitle">Issue Token</h4>
                            </div>
                            <div className="card-content">
                                <form onSubmit={this.onSubmit}>
                                <p>
                                <label>
                                    <input name="group1" type="radio" checked 
                                    value="equity"
                                     onChange={(e)=>{this.setState({token: e.target.value})}}
                                    />
                                    <span>Equity</span>
                                </label>
                                </p>
                                <p>
                                <label>
                                    <input name="group1" type="radio"
                                    value="debt"
                                    onChange={(e)=>{this.setState({token: e.target.value})}}
                                     />
                                    <span>Debt</span>
                                </label>
                                </p>
                                <div className="input-field">
                                        <input type="text" 
                                        value={this.state.noShare}
                                         onChange={(e) => {this.setState({noShare: e.target.value}) }} required
                                         autoComplete='off'
                                         />
                                        <label htmlFor="email">Price per Share (USD) </label>
                                    </div>

                                    <div className="input-field">
                                        <input type="text" 
                                        value={this.state.enterShare}
                                         onChange={this.enterIssue }
                                          required
                                         autoComplete='off'
                                         />
                                        <label htmlFor="email">No of Shares to be issued  </label>
                                    </div>
                                    <div className="input-field">
                                        <input type="text" 
                                        value={this.state.address}
                                         onChange={(evt) => { this.setState({address: evt.target.value})}} required/>
                                        <label htmlFor="offCode">wallet Address</label>
                                    </div>
                                    <div className="input-field">
                                        <input type="text"
                                         onChange={(evt) => {this.setState({eth: evt.target.value}) }}
                                         value={this.state.eth}
                                          required/>
                                        <label htmlFor="offCode">Ethereum</label>
                                    </div>
                                    <div className="form-submit center">
                                        <button type="submit" className="dropbtn1" style={{marginTop:"10px"}}>Buy token</button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default Coin;
